import type { SlotRosterDetailsInput } from '@sportninja/common/services/teamBalance'
import type { PendingRosterDetails } from '../types/balanceGrid'

/**
 * Inon, Oct 2 — the Position / Number each save in flight is writing, as its row
 * draws it until the refetch lands: the picked position's label (from the options the
 * editor offered — none when they do not name it, and the row keeps its own), and the
 * number, where an explicit `null` is a clear and stays apart from "unchanged".
 */
export const pendingRosterDetailsOf = (
  saves: Readonly<
    Record<
      string,
      Pick<SlotRosterDetailsInput, 'player_type_id' | 'player_number'>
    >
  >,
  positionOptions: readonly { label: string; value: string }[]
): Record<string, PendingRosterDetails> => {
  const pending: Record<string, PendingRosterDetails> = {}
  for (const [slotId, save] of Object.entries(saves)) {
    const details: PendingRosterDetails = {}
    if (save.player_type_id !== undefined) {
      const label = positionOptions.find(
        (option) => option.value === String(save.player_type_id)
      )?.label
      if (label !== undefined) {
        details.positionLabel = label
      }
    }
    if (save.player_number !== undefined) {
      details.playerNumber = save.player_number
    }
    pending[slotId] = details
  }

  return pending
}

/**
 * The same, as one string, so the grid can tell when what a row draws changed even
 * though no column VALUE did (AG Grid repaints on value changes only).
 */
export const pendingRosterDetailsKey = (
  pending: Readonly<Record<string, PendingRosterDetails>> | undefined
): string =>
  Object.entries(pending ?? {})
    .map(
      ([slotId, details]) =>
        `${slotId}=${details.positionLabel ?? ''}/${
          details.playerNumber === undefined ? '' : String(details.playerNumber)
        }`
    )
    .join('|')
